import React from "react";
import {GraphQlSelect} from "./GraphQlSelect";
import {useCostSupplierQueryQuery} from "../../generated/graphql";

export const CostSupplierSelect = (props) => {
    const query = useCostSupplierQueryQuery();
    return <GraphQlSelect queryResult={query} {...props}  labelField="label" />;
}
